import React from "react"

import { Link } from '@mui/joy';
import { Icon } from '../../assets';

const Anchor = ({ href, target = "_self", level = 'body-md', icon, iconfamily = 'fal', disabled, variant, underline, className, children , style}) => {
    className = (typeof className != typeof undefined) ? className+" mtska-link mtska-link-"+level : "mtska-link mtska-link-"+level;
    if (children == null) {
        className += ' iconic';
    }

    return (
        <Link 
            level={level} 
            target={target} 
            href={href} 
            disabled={disabled} 
            variant={variant} 
            underline={underline} 
            className={className}
            style={style}
            startDecorator={(icon) ? (
                <Icon icon={icon} family={iconfamily}/>
            ) : (
                <></>
            )}
        >
            {children}
        </Link>
    );
}

export default Anchor;